import { render, staticRenderFns } from "./CustomForms.vue?vue&type=template&id=3e8afc56&scoped=true&"
import script from "./CustomForms.vue?vue&type=script&lang=ts&"
export * from "./CustomForms.vue?vue&type=script&lang=ts&"
import style0 from "./CustomForms.vue?vue&type=style&index=0&id=3e8afc56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8afc56",
  null
  
)

export default component.exports